import script from "./MoreWarehouse.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoreWarehouse.vue?vue&type=script&lang=ts&setup=true"

import "./MoreWarehouse.vue?vue&type=style&index=0&id=671a98f1&lang=scss"

const __exports__ = script;

export default __exports__